module.exports = __webpack_public_path__ + "img/bg_arrow.3d0a686d.svg";